module.exports = __webpack_public_path__ + "img/light_shape_square.fd1ec2b6.svg";